/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const SocialMediaYoutube16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.8 4.8c-.2-1.3-.8-2.2-2.2-2.4C11.4 2 8 2 8 2s-3.4 0-5.6.4C1 2.6.3 3.5.2 4.8 0 6.1 0 8 0 8s0 1.9.2 3.2.8 2.2 2.2 2.4C4.6 14 8 14 8 14s3.4 0 5.6-.4c1.4-.3 2-1.1 2.2-2.4S16 8 16 8s0-1.9-.2-3.2M6 11V5l5 3z"
    />
  </svg>
);

export const __descriptor_SocialMediaYoutube = {
  name: "SocialMediaYoutube",
  instances: [{ size: 16, Component: SocialMediaYoutube16 }],
} as const;
